var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGaby(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 261,
    height: 147,
    viewBox: "0 0 261 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 261,
    height: 147,
    rx: 20,
    fill: "#F4F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 60.4502C77.6131 60.4502 75.3239 61.3984 73.636 63.0862C71.9482 64.7741 71 67.0632 71 69.4502C71.0009 71.2006 71.5122 72.9128 72.4713 74.377C73.4304 75.8413 74.7957 76.994 76.4 77.6942V84.7502C76.4 85.2488 76.8014 85.6502 77.3 85.6502H82.7C83.1986 85.6502 83.6 85.2488 83.6 84.7502V77.687C85.2032 76.9873 86.5677 75.8357 87.5267 74.3728C88.4857 72.91 88.9977 71.1994 89 69.4502C89 67.0632 88.0518 64.7741 86.364 63.0862C84.6761 61.3984 82.3869 60.4502 80 60.4502Z",
    fill: "url(#paint0_linear_703_2206)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M78.5606 86.55C79.0577 86.55 79.4606 86.1471 79.4606 85.65C79.4606 85.1529 79.0577 84.75 78.5606 84.75C78.0636 84.75 77.6606 85.1529 77.6606 85.65C77.6606 86.1471 78.0636 86.55 78.5606 86.55Z",
    fill: "url(#paint1_linear_703_2206)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4396 86.55C81.9366 86.55 82.3396 86.1471 82.3396 85.65C82.3396 85.1529 81.9366 84.75 81.4396 84.75C80.9425 84.75 80.5396 85.1529 80.5396 85.65C80.5396 86.1471 80.9425 86.55 81.4396 86.55Z",
    fill: "url(#paint2_linear_703_2206)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6999 80.25H77.2999C76.8028 80.25 76.3999 80.6529 76.3999 81.15V84.75C76.3999 85.2471 76.8028 85.65 77.2999 85.65H82.6999C83.197 85.65 83.5999 85.2471 83.5999 84.75V81.15C83.5999 80.6529 83.197 80.25 82.6999 80.25Z",
    fill: "url(#paint3_linear_703_2206)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7499 80.25H76.2511C75.8365 80.25 75.5005 80.6529 75.5005 81.15C75.5005 81.6471 75.8365 82.05 76.2511 82.05H83.7499C84.1644 82.05 84.5005 81.6471 84.5005 81.15C84.5005 80.6529 84.1644 80.25 83.7499 80.25Z",
    fill: "url(#paint4_linear_703_2206)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7499 82.0508H76.2511C75.8365 82.0508 75.5005 82.4537 75.5005 82.9508C75.5005 83.4478 75.8365 83.8508 76.2511 83.8508H83.7499C84.1644 83.8508 84.5005 83.4478 84.5005 82.9508C84.5005 82.4537 84.1644 82.0508 83.7499 82.0508Z",
    fill: "url(#paint5_linear_703_2206)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7499 78.4502H76.2511C75.8365 78.4502 75.5005 78.8531 75.5005 79.3502C75.5005 79.8473 75.8365 80.2502 76.2511 80.2502H83.7499C84.1644 80.2502 84.5005 79.8473 84.5005 79.3502C84.5005 78.8531 84.1644 78.4502 83.7499 78.4502Z",
    fill: "url(#paint6_linear_703_2206)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0003 62.249C76.0349 62.249 72.8003 65.4836 72.8003 69.449C72.8003 69.6877 72.8951 69.9168 73.0639 70.0856C73.2327 70.2544 73.4616 70.349 73.7003 70.349C73.939 70.349 74.1679 70.2544 74.3367 70.0856C74.5055 69.9168 74.6003 69.6877 74.6003 69.449C74.6003 66.4574 77.0069 64.049 80.0003 64.049C80.239 64.049 80.4679 63.9544 80.6367 63.7856C80.8055 63.6168 80.9003 63.3877 80.9003 63.149C80.9003 62.9103 80.8055 62.6815 80.6367 62.5127C80.4679 62.3439 80.239 62.249 80.0003 62.249Z",
    fill: "url(#paint7_linear_703_2206)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.34 74.496H112.18V77.016C111.244 77.688 110.092 78.072 108.964 78.072C106.156 78.072 103.78 75.624 103.78 72.744C103.78 69.888 106.156 67.44 108.964 67.44C110.476 67.44 112.084 68.16 113.068 69.288L115.636 66.984C113.98 65.256 111.436 64.224 108.964 64.224C104.188 64.224 100.132 68.112 100.132 72.744C100.132 77.376 104.188 81.288 108.964 81.288C111.436 81.288 113.98 80.256 115.636 78.528V71.736H108.34V74.496ZM135.512 81H139.496L132.776 64.512H128.816L122.096 81H126.056L127.112 78.408H134.456L135.512 81ZM128.336 75.408L130.784 69.384L133.232 75.408H128.336ZM146.383 81H155.047C158.191 81 160.447 79.176 160.447 76.536C160.447 74.712 159.343 73.176 157.423 72.312C158.887 71.544 159.727 70.32 159.727 68.64C159.727 66.24 157.687 64.512 154.735 64.512H146.383V81ZM149.911 71.16V67.536H153.847C155.167 67.536 156.103 68.304 156.103 69.336C156.103 70.392 155.167 71.16 153.847 71.16H149.911ZM149.911 77.976V73.944H154.399C155.815 73.944 156.823 74.784 156.823 75.96C156.823 77.136 155.815 77.976 154.399 77.976H149.911ZM172.74 81H176.316V75.048L182.748 64.512H178.788L174.516 71.736L170.412 64.512H166.284L172.74 75.048V81Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_703_2206",
    x1: 71,
    y1: 73.0502,
    x2: 89,
    y2: 73.0502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCD635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7A928"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_703_2206",
    x1: 77.6606,
    y1: 85.65,
    x2: 79.4606,
    y2: 85.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABDC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_703_2206",
    x1: 80.5396,
    y1: 85.65,
    x2: 82.3396,
    y2: 85.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABDC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_703_2206",
    x1: 76.3999,
    y1: 82.05,
    x2: 83.5999,
    y2: 82.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#485960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D4E55"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_703_2206",
    x1: 75.5005,
    y1: 81.15,
    x2: 84.5005,
    y2: 81.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABDC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_703_2206",
    x1: 75.5005,
    y1: 82.9508,
    x2: 84.5005,
    y2: 82.9508,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABDC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_703_2206",
    x1: 75.5005,
    y1: 79.3502,
    x2: 84.5005,
    y2: 79.3502,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CAD1D8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BABDC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_703_2206",
    x1: 72.8003,
    y1: 66.3062,
    x2: 80.9129,
    y2: 66.3062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A320"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F47E1F"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGaby);
export default __webpack_public_path__ + "static/media/gaby.432d29b436f7c5ad35951f446d2bcb69.svg";
export { ForwardRef as ReactComponent };